module.exports = __webpack_public_path__ + "static/background-hero-athletico-paranaense-xl-2cda4c502a6c188e3b24334ec049bf45.jpg";